/* eslint-disable */
import * as types from './graphql'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel-plugin for production.
 */
const documents = {
  '\n  fragment UserFragment on User {\n    id\n    name\n  }\n':
    types.UserFragmentFragmentDoc,
  '\n    mutation AuthRefreshToken {\n      __typename\n    }\n  ':
    types.AuthRefreshTokenDocument,
  '\n    query AuthLogin {\n      __typename\n    }\n  ':
    types.AuthLoginDocument,
  '\n    mutation ExampleUpdateUser($id: ID!, $name: String) {\n      updateUser(id: $id, name: $name) {\n        ...UserFragment\n      }\n    }\n  ':
    types.ExampleUpdateUserDocument,
  '\n    query ExampleUserById($id: ID!) {\n      User(id: $id) {\n        ...UserFragment\n      }\n    }\n  ':
    types.ExampleUserByIdDocument,
}

/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 *
 *
 * @example
 * ```ts
 * const query = gql(`query GetUser($id: ID!) { user(id: $id) { name } }`);
 * ```
 *
 * The query argument is unknown!
 * Please regenerate the types.
 */
export function gql(source: string): unknown

/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(
  source: '\n  fragment UserFragment on User {\n    id\n    name\n  }\n'
): (typeof documents)['\n  fragment UserFragment on User {\n    id\n    name\n  }\n']
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(
  source: '\n    mutation AuthRefreshToken {\n      __typename\n    }\n  '
): (typeof documents)['\n    mutation AuthRefreshToken {\n      __typename\n    }\n  ']
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(
  source: '\n    query AuthLogin {\n      __typename\n    }\n  '
): (typeof documents)['\n    query AuthLogin {\n      __typename\n    }\n  ']
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(
  source: '\n    mutation ExampleUpdateUser($id: ID!, $name: String) {\n      updateUser(id: $id, name: $name) {\n        ...UserFragment\n      }\n    }\n  '
): (typeof documents)['\n    mutation ExampleUpdateUser($id: ID!, $name: String) {\n      updateUser(id: $id, name: $name) {\n        ...UserFragment\n      }\n    }\n  ']
/**
 * The gql function is used to parse GraphQL queries into a document that can be used by GraphQL clients.
 */
export function gql(
  source: '\n    query ExampleUserById($id: ID!) {\n      User(id: $id) {\n        ...UserFragment\n      }\n    }\n  '
): (typeof documents)['\n    query ExampleUserById($id: ID!) {\n      User(id: $id) {\n        ...UserFragment\n      }\n    }\n  ']

export function gql(source: string) {
  return (documents as any)[source] ?? {}
}

export type DocumentType<TDocumentNode extends DocumentNode<any, any>> =
  TDocumentNode extends DocumentNode<infer TType, any> ? TType : never
